import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "./SockSection.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { BASE_URL } from "../../constant";

const SockSection = () => {
  const [socks, setSocks] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    const fetchSocksImages = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/homepage/socktype/get-all`
        );
        setSocks(response.data);
      } catch (error) {
        console.error("Error fetching sock images:", error);
      }
    };

    fetchSocksImages();
  }, []);
  const handleButtonClick = (redirectUrl) => {
    if (redirectUrl) {
      navigate(redirectUrl);
    } else {
      navigate("/shop");
    }
  };
  return (
    <div className="sock-section">
      <div className="sock-section__desktop-view">
        {socks.map((sock, index) => (
          <div key={index} className="sock-section__item">
            <img src={sock.url} alt={`${sock.title} Socks`} />
            <div className="sock-section_content">
              <h2 className="sock-section_heading">{sock.title}</h2>
              <p>{sock.description}</p>
              <button onClick={() => handleButtonClick(sock.redirectUrl)}>
                Shop Now
              </button>
            </div>
          </div>
        ))}
      </div>
      <div className="sock-section__mobile-view">
        <Swiper
          effect={"coverflow"}
          centeredSlides
          modules={[EffectCoverflow]}
          slidesPerView={"auto"}
          initialSlide={2}
          spaceBetween={10}
          grabCursor
          coverflowEffect={{
            rotate: 0,
            stretch: 0,
            depth: 0,
            modifier: 1,
            slideShadows: false,
          }}
        >
          {socks.map((sock, index) => (
            <SwiperSlide className="socksslide">
              <img src={sock.url} alt={`${sock.title} Socks`} />
              <button
                className="sock-section__button"
                onClick={() => handleButtonClick(sock.redirectUrl)}
              >
                Shop Now
              </button>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default SockSection;
